import utils from "../../Utils";
import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import HealthCareProviderProfile from "../../models/domain/HealthCareProviderProfile";

interface preferredDoctorSettings {
  enabledDoctors: string[];
  isCreateNewPatient: boolean;
  preferedDoctor: HealthCareProviderProfile | null;
  setPreferedDoctor: Function | null;
}
export default function PreferredDoctors(props: preferredDoctorSettings) {
  const [userProfile, setUserProfile] = useState(utils.retrieveUserProfile());

  const [selectedDoctor, setSelectedDoctor] =
    useState<HealthCareProviderProfile>(
      props.isCreateNewPatient
        ? (props.preferedDoctor as HealthCareProviderProfile)
        : utils.defaultDoctor
    );

  useEffect(() => {
    let _profile: HealthCareProviderProfile | undefined;

    if (props.isCreateNewPatient) {
      _profile =
        props.preferedDoctor ?? userProfile?.associatedHealthCareProviders?.[0];
    } else {
      if (props.enabledDoctors.length > 0) {
        _profile =
          userProfile?.associatedHealthCareProviders?.find(
            (profile) => profile.id === props.preferedDoctor?.id
          ) ||
          userProfile?.associatedHealthCareProviders?.find(
            (profile) => profile.id === props.enabledDoctors[0]
          );
      }

      if (!_profile) {
        _profile = userProfile?.associatedHealthCareProviders?.[0];
      }
    }

    if (_profile) {
      setSelectedDoctor(_profile);
      props?.setPreferedDoctor?.(_profile);
      localStorage.setItem(
        "preferredDoctorForAppointmentBooking",
        JSON.stringify(_profile)
      );
    }
  }, [props.enabledDoctors, props.isCreateNewPatient, props.preferedDoctor]);

  return (
    <>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="noteType"
          name="noteType"
          value={selectedDoctor?.id ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            console.log(event.target.value);
            const _profile = userProfile.associatedHealthCareProviders.find(
              (profile) => profile.id === event.target.value
            );
            console.log(_profile);

            setSelectedDoctor(_profile!);
            props?.setPreferedDoctor?.(_profile);
            localStorage.setItem(
              "preferredDoctorForAppointmentBooking",
              JSON.stringify(_profile || {})
            );
            console.log(selectedDoctor);
          }}
        >
          {userProfile.associatedHealthCareProviders.map((profile, index) => (
            <FormControlLabel
              key={index}
              value={profile.id}
              control={<Radio />}
              style={{ marginTop: 0, marginBottom: 2 }}
              disabled={
                !props.isCreateNewPatient &&
                props.enabledDoctors.length > 0 &&
                !props.enabledDoctors.includes(profile.id)
              }
              label={profile.name}
            />
          ))}
        </RadioGroup>
        {/* {!props.isCreateNewPatient &&
          userProfile.associatedHealthCareProviders.filter((profile) =>
            props.enabledDoctors.includes(profile.id)
          ).length === 0 &&
          "Your prefered doctor is not available in this clinic."} */}
      </FormControl>
    </>
  );
}
